import React from "react";
import { Link } from "react-router-dom";

import "../AccountReturn/AccountReturn.css";

export default function TopUpCancel() {
  return (
    <div className="account-return-page">
      <div className="account-return-overlay" />
      <div className="container account-return-container">
        <div className="account-return-card text-center">
          <div
            className="account-return-icon-wrapper"
            style={{
              background: "linear-gradient(135deg, #dc3545, #b02a37)",
              boxShadow: "0 12px 22px rgba(220, 53, 69, 0.32)",
            }}
            aria-hidden="true"
          >
            <span className="account-return-icon">×</span>
          </div>

          <p className="account-return-badge">Payment Cancelled</p>

          <h1 className="account-return-title">Top-up not completed</h1>

          <p className="account-return-description">
            Your wallet was not charged. You can start a new top-up whenever you
            are ready.
          </p>

          <div className="account-return-actions">
            <Link
              to="/money-credit-dashboard"
              className="account-return-primary-btn"
            >
              Back to Wallet
            </Link>
            <Link to="/dashboard" className="account-return-secondary-btn">
              Back to Dashboard
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
